<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="10">
          <!-- <el-col :span="6">
            <el-form-item label="任务店铺" prop="shopInfo">
              <el-select v-model="queryForm.shopInfo" clearable placeholder="请选择店铺">
                <el-option
                    v-for="item in allShops"
                    :key="item.id"
                    :label="item.shopName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="任务类型" prop="taskType">
              <el-select v-model="queryForm.taskType" clearable placeholder="请选择任务类型">
                <el-option
                    v-for="item in allTaskTypes"
                    :key="item.id"
                    :label="item.taskName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态" prop="status">
              <el-select v-model="queryForm.status" clearable placeholder="请选择任务类型">
                <el-option
                    v-for="item in statusOptions"
                    :key="item.flag"
                    :label="item.value"
                    :value="item.flag"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="任务编号" prop="taskId">
              <el-input v-model="queryForm.taskId" placeholder="请输入任务编号"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="商品链接" prop="goodUrl">
              <el-input v-model="queryForm.goodUrl" placeholder="请输入商品链接"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
              <!--<el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出
              </el-button>-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <!--<el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('发布任务')">发布任务
      </el-button>-->
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="releaseTask">发布任务
      </el-button>
      <div v-for="(item, index) in tableData" :key="index" style="margin-top: 20px;margin-bottom:20px; width: 100%;">
        <el-row :gutter="0">
          <el-col :span="24">
            <table border="0" style="border-collapse:collapse;border: 1px solid #04befe;border-radius: 15px;">
              <tr>
                <td colspan="7" width="58.31%" >
                  <div style="width:100%;display: flex; flex-flow: row nowrap;justify-content: space-between;">
                  <span style="text-align: left;margin-left: 2%;width: 50%;">
                    <!-- {{ item.b2cShops.shopName }} -->
                    <span style="margin-left: 2%;color: crimson;">
                      任务时间: {{ item.b2cTasks.createTime }}
                    </span>
                  </span>
                  <span style="margin-right: 2%;color: red;">{{ item.b2cTaskType.taskName }}</span>
                  </div>
                </td>
                <td><span>总单数：</span>{{ item.totalAllOrderNum }}</td>
                <td><span>任务编号：</span>{{ item.b2cTasks.id }}</td>
                <td>
                  <el-button type="text" @click="gotToDetail(item)">[查看详情]</el-button>
                </td>
                <td>
                  <el-button type="text" @click="goTaskRelease(item)">[{{isShowPayBtn(item)?"支付发布":"重新发布"}}]</el-button>
                </td>
                <td>
                  <el-button size="small" style="border-color:red;color: red">进行中</el-button>
                </td>
              </tr>
              <tr>
                <td style="width: 8%;">
                  <el-image :src="item.goodImgUrl" style="margin: 1%;"></el-image>
                </td>
                <td style="width: 15%"><span>{{ item.goodTitle }}</span></td>
                <td>
                  <div>{{ item.statusInfo.待放出||item.statusInfo.保存待扣款 ? item.statusInfo.待放出||item.statusInfo.保存待扣款 : 0 }}</div>
                  <div>待放出</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.准备中 ? item.statusInfo.准备中 : 0 }}</div>
                  <div>准备中</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.已下单 ? item.statusInfo.已下单 : 0 }}</div>
                  <div>已下单</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.复活 ? item.statusInfo.复活 : 0 }}</div>
                  <div>复活</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.超时发货 ? item.statusInfo.超时发货 : 0 }}</div>
                  <div>超时发货</div>
                </td>
                <td style="color: red">
                  <div>{{ item.statusInfo.申诉审核中 ? item.statusInfo.申诉审核中 : 0 }}</div>
                  <div>申诉审核中</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.申诉完成 ? item.statusInfo.申诉完成 : 0 }}</div>
                  <div>申诉完成</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.退款审核中 ? item.statusInfo.退款审核中 : 0 }}</div>
                  <div>退款审核中</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.已完成 ? item.statusInfo.已完成 : 0 }}</div>
                  <div>已完成</div>
                </td>
                <td>
                  <div>{{ item.statusInfo.已退款 ? item.statusInfo.已退款 : 0 }}</div>
                  <div>已退款</div>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </div>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
<!--
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="请选择任务类型" prop="taskType">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                请选择任务类型
              </span>
              <el-select v-model="dialogForm.taskType" clearable placeholder="请选择" @change="taskTypeChange">
                <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.taskName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20">
            <el-form-item label="请选择店铺" prop="shopInfo">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                请选择店铺
              </span>
              <el-select v-model="dialogForm.shopInfo" clearable placeholder="请选择">
                <el-option
                    v-for="spItem in allShops"
                    :key="spItem.id"
                    :label="spItem.shopName"
                    :value="spItem.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="text" @click="addShops">
              <i class="el-icon-plus"></i>
              <span>添加店铺</span>
            </el-button>
          </el-col>
        </el-row>
        <div class="clearfix"
             style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
          <span style="color: #FFFFFF; font-size: 1rem">设置商品信息</span>
        </div>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="任务名称" prop="taskName">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                任务名称
              </span>
              <el-input v-model="dialogForm.taskName" placeholder="请用类目+产品(例如：男装夹克)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20">
            <el-form-item label="宝贝链接" prop="productUrl">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝链接
              </span>
              <el-input v-model="dialogForm.productUrl" placeholder="请填写正确的宝贝链接"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-show="isShowGetLinkBtn">
            <el-button type="text" @click="getTaobaoGood(null)">
              <i class="el-icon-refresh"></i>
              <span>获取宝贝数据</span>
            </el-button>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20">
            <el-form-item label="宝贝标题" prop="productUrl">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝标题
              </span>
              <el-input v-model="dialogForm.goodTitle" placeholder="请填写宝贝标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="宝贝主图" prop="goodImgUrl">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝主图
              </span>
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="dialogForm.goodImgUrl" :src="dialogForm.goodImgUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：上传“宝贝主图”，确保与搜索页面展示的图片一致 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="宝贝价格(元)" prop="businessPrice">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝价格(元)
              </span>
              <el-input v-model="dialogForm.businessPrice" placeholder="请输入宝贝价格"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：用户拍下时的付款价格，如不同等级买号看到商品价格不同，取最大值   </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="每单怕(件)" prop="billProductNum">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                每单怕(件)
              </span>
              <el-input v-model="dialogForm.billProductNum" placeholder="请输入每天拍件数"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：总金额 {{
                    isNaN(parseInt(dialogForm.billProductNum) * parseFloat(dialogForm.businessPrice)) ? 0 : parseInt(dialogForm.billProductNum) * parseFloat(dialogForm.businessPrice)
                  }} 元 【不含运费】 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="搜索价格(元)" prop="sreachPrice">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                搜索价格(元)
              </span>
              <el-input v-model="dialogForm.sreachPrice" placeholder="请输入搜索价格"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：务必亲自在手机端搜索，确认价格准确 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-row :gutter="2" style="line-height: 33px;margin-left: 20%;font-size: 0.5rem">
              <el-col :span="2" style="text-align: right;">
                <span class="blink">多链接</span>
              </el-col>
              <el-col :span="4" style="padding-left: 1rem;">
                <el-button type="text" style="color: red;font-size: 0.5rem;margin-top: -3px" @click="addGoods">
                  <i class="el-icon-plus"></i>
                  添加商品(元/条)
                </el-button>
              </el-col>
              <el-col :span="9" style="padding-left: 1.2rem">
                <div style="color: red;width: 100%;text-align: left;">
                  <i class="el-icon-question"></i>
                  <span>提示：添加一起购买的商品(最多5个)</span>
                </div>
              </el-col>
              <el-col :span="3">
                <span>小计：<span style="color: red">{{ dialogForm.goodPriceTotal }}</span>元</span>
              </el-col>
            </el-row>
            <el-row :gutter="2" style="margin-top:1%;display: flex;align-items: center;" v-if="goodsTableVisible"
                    v-for="(goodItem, index) in dialogForm.goodsAry" :key="index">
              <el-col :span="15" class="boxself">
                <el-row :gutter="0" style="margin: 2%;display: flex;align-items: center;">
                  <el-col :span="6">
                    <el-upload
                        class="itemCls"
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="image/png,image/gif,image/jpg,image/jpeg"
                        :on-success="handleGoodSuccess.bind(null, {index: index, data:goodItem})"
                        :on-remove="handleAvatarRemove">
                      <img v-if="goodItem.goodImageUrl" :src="goodItem.goodImageUrl" class="avatar">
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-col>
                  <el-col :span="17" style="margin-left: 4%;font-size: 0.6rem">
                    <el-row :gutter="0">
                      <el-col :span="17">
                        <el-form-item label="链接" prop="goodItem.goodUrl" label-width="23%">
                          <el-input v-model="goodItem.goodUrl"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-button type="danger" size="mini" @click="getTaobaoGood(goodItem)"
                                   style="margin: 5%; margin-top: 1%;">
                          <i class="el-icon-refresh"></i>
                          <span>获取数据</span>
                        </el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0">
                      <el-col :span="17">
                        <el-form-item label="关键词" prop="goodItem.mainKey" label-width="23%">
                          <el-input v-model="goodItem.mainKey"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0">
                      <el-col :span="17">
                        <el-form-item label="标题" prop="goodItem.goodTitle" label-width="23%">
                          <el-input v-model="goodItem.goodTitle"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0">
                      <el-col :span="8">
                        <el-form-item label="单价" prop="goodItem.goodPrice" label-width="33%">
                          <el-input v-model="goodItem.goodPrice"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="数量" prop="goodItem.goodNum" label-width="33%">
                          <el-input v-model="goodItem.goodNum"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="规格" prop="goodItem.goodRule" label-width="33%">
                          <el-input v-model="goodItem.goodRule"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="2">
                <el-button type="danger" icon="el-icon-delete" circle style="margin: 5%;"
                           @click="removeGood(goodItem)"></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="领劵链接" prop="couponUrl">
              <el-input v-model="dialogForm.couponUrl" placeholder="优惠券领取链接"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：优惠券链接 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="是否包邮" prop="isFreeShipping">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                是否包邮
              </span>
              <el-radio-group v-model="dialogForm.isFreeShipping">
                <el-radio :label="0">不包邮</el-radio>
                <el-radio :label="1">包邮</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="物流" prop="logisticsCompany">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                物流
              </span>
              <el-select v-model="dialogForm.logisticsCompany" clearable placeholder="请选择">
                <el-option
                    v-for="item in allExpress"
                    :key="item.id"
                    :label="item.expressName"
                    :value="item.expressNumber"
                >
                </el-option>
              </el-select>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：礼品单物流上线，真实发货，买家真实签收！ </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="clearfix"
             style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
          <span style="color: #FFFFFF; font-size: 1rem">设置如何找到商品</span>
        </div>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="商品排序方式" prop="goodsSortType">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                商品排序方式
              </span>
              <el-radio-group v-model="dialogForm.goodsSortType">
                <el-radio :label="0">综合</el-radio>
                <el-radio :label="1">销量</el-radio>
              </el-radio-group>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：强烈建议销量排序，商品位置更稳定更好找 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="商品现有收货人数或付款人数约(人)" prop="recivePersons">
              <el-input type="number" v-model="dialogForm.recivePersons" placeholder="人数"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>提示：此处为手机淘宝销量优先搜索列表页显示的收货人数 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12">
            <el-form-item label="价格区间">
              <el-input v-model="dialogForm.startPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1" align="center"><span style="line-height: 40px;">-</span></el-col>
          <el-col :span="4">
            <el-input v-model="dialogForm.endPrice"></el-input>
          </el-col>
          <el-col :span="2"><span style="line-height: 40px;">元</span></el-col>
          <div
              style="color: red;width: 100%;text-align: left;font-size: 0.5rem;margin-top: -1%;float: left;margin-left: 16.4rem;">
            <i class="el-icon-question"></i>
            <span>提示：如果商品不好找，强烈建议添加价格区间、商品所在地方便用户找到你的商品。</span>
          </div>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20">
            <el-form-item label="商品所在地" style="margin-top: 2%;">
              <v-distpicker only-province
                            @selected="onProvinceSelected"></v-distpicker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="21" style="margin-top: 5px;">
            <el-form-item label="宝贝详情问答(2-10个字)" prop="goodInfoAnswer">
              <el-input v-model="dialogForm.goodInfoAnswer"></el-input>
              <span style="font-size: 4px;">通过找到商家设置的问答来增加买手在商品页的停留时间<span style="color: red"> 【 了解如何设置】 </span></span>
            </el-form-item>
          </el-col>
          <div
              style="color: red;width: 100%;text-align: left;font-size: 0.5rem;margin-top: -4%;float: left;margin-left: 16.4rem;">
            <i class="el-icon-question"></i>
            <span>提示：请选中你的商品属性或商品详情中的某文字作为关键词，最少2个字，最多10个字，<br>不要输入标题符号、空格、特殊字符。</span>
          </div>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="订单留言" prop="orderLeaveMessage">
              <el-input v-model="dialogForm.orderLeaveMessage" placeholder="买家留言"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
                <i class="el-icon-question"></i>
                <span>用户拍下商品所需要填写的买家留言；出于安全考虑不建议大批量使用  </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="clearfix"
             style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
          <span style="color: #FFFFFF; font-size: 1rem">任务类型和单数</span>
        </div>
        <el-row :gutter="5">
          <el-col :span="20" style="margin:12px 3.1rem; margin-top: 5px;">
            <div style="color: red;width: 100%;text-align: left;font-size: 0.5rem">
              <i class="el-icon-question"></i>
              <span>必须至少选择一项任务类型（勾选展开填写明细）</span>
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row>
              <el-col :span="6" style="text-align: right;line-height: 20px;margin-right: 0.5rem">
                <el-checkbox v-model="dialogForm.taskChecked" @change="taskChanged('taskAry')">普通任务(+0.0金/单)
                </el-checkbox>
              </el-col>
              <el-col :span="14">
                <div style="line-height:20px;color: red;width: 100%;text-align: left;font-size: 0.5rem">
                  <i class="el-icon-question"></i>
                  <span>默认为5星无评价内容，如需评价请备注，但不可规定评价内容 </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="dialogForm.taskChecked"
                    style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
              <el-col :span="24">
                <div>
                  <el-row :gutter="0" class="keywordCls" align="middle" type="flex"
                          v-for="(it, index) in dialogForm.taskAry" :key="it">
                    <el-col :span="6">
                      <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                        下单关键词
                        </span>
                        <el-input v-model="it.orderKeys"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="添加" label-width="40%">
                        <el-input v-model="it.orderAdd"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item label="单，备用关键词" label-width="48%">
                        <el-input v-model="it.orderBackKey" placeholder="(选填)备用关键词"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5" style="margin-right: 5px;">
                      <el-form-item label="，颜色尺码" label-width="48%">
                        <el-input v-model="it.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1" style="padding-left: 3%;text-align: right" v-if="it.isShowRemove">
                      <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                 @click="removeOrderKeys('taskAry', it)"></el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="5">
                    <el-col :span="24">
                      <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                        <el-col :span="12" style="padding-left: 1rem;">
                          <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('taskAry')">
                            <i class="el-icon-plus"></i>
                            添加关键词
                          </el-button>
                        </el-col>
                        <el-col :span="12" style="line-height: 43px;">
                          <span>总计：<span style="color: red">{{ totalTaskContent }}</span>单</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom: 10px;">
                    <el-col :span="6" style="text-align: right;line-height: 20px;margin-left: 2%;">
                      <el-checkbox v-model="dialogForm.taskReviewChecked">只需5星好评，不需要评论</el-checkbox>
                    </el-col>
                    <el-col :span="14">
                      <div
                          style="line-height:20px;color: red;width: 100%;text-align: left;font-size: 0.6rem;margin-left: 5%;">
                        <i class="el-icon-question"></i>
                        <span>将在买手端提醒买手只提交好评 </span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row style="padding-left: 6.3%">
              <el-col :span="6" style="text-align: right;line-height: 20px;margin-right: 0.5rem">
                <el-checkbox v-model="dialogForm.textChecked" @change="taskChanged('textAry')">指定文字好评任务(+1.0金/单)
                </el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="dialogForm.textChecked"
                    style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
              <el-col :span="24">
                <div>
                  <el-row :gutter="0" class="keywordCls" align="middle" type="flex" v-for="its in dialogForm.textAry">
                    <el-col :span="6">
                      <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                        下单关键词
                        </span>
                        <el-input v-model="its.orderKeys"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="添加" label-width="35%">
                        <el-input v-model="its.orderAdd"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="单，备用关键词" label-width="42%">
                        <el-input v-model="its.orderBackKey" placeholder="(选填)备用关键词"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" style="padding-left: 3%;text-align: right" v-if="its.isShowRemove">
                      <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                 @click="removeOrderKeys('textAry', its)"></el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="5">
                    <el-col :span="24">
                      <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                        <el-col :span="12" style="padding-left: 1rem;">
                          <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('textAry')">
                            <i class="el-icon-plus"></i>
                            添加关键词
                          </el-button>
                        </el-col>
                        <el-col :span="12" style="line-height: 43px;">
                          <span>总计：<span style="color: red">{{ totalTextContent }}</span>单</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-row :gutter="2" align="middle" type="flex" v-if="dialogForm.textContent">
                        <el-col :span="24" style="background-color: mistyrose;max-height: 30px;margin: 5px;">
                          <span style="font-size: smaller;margin: 5px;">设置文字好评内容</span>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0" class="contentCls" v-for="(subIt, index) in dialogForm.textContentAry"
                              :key="index" v-if="dialogForm.textContent">
                        <el-col :span="24">
                          <el-row :gutter="2">
                            <el-col :span="24"
                                    style="background-color: mistyrose;max-height: 30px;margin: 5px;width: 99%;">
                              <span style="font-size: smaller;margin: 5px;">设置地{{ index + 1 }}单文字好评内容</span>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0">
                            <el-col :span="16">
                              <el-form-item label-width="1%">
                                <el-input v-model="subIt.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0">
                            <el-col :span="20">
                              <el-form-item label-width="1%">
                                <el-input type="textarea" v-model="subIt.reviewContent"
                                          placeholder="(选填)完整的评价内容， 最多999个字。未填写则在买手端提醒买手自由发挥。"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row style="padding-left: 6.3%">
              <el-col :span="6" style="text-align: right;line-height: 20px;margin-right: 0.5rem">
                <el-checkbox v-model="dialogForm.imageChecked" @change="taskChanged('imageAry')">指定图文好评任务(+1.5金/单)
                </el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="dialogForm.imageChecked"
                    style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
              <el-col :span="24">
                <div>
                  <el-row :gutter="0" class="keywordCls" align="middle" type="flex" v-for="itl in dialogForm.imageAry">
                    <el-col :span="6">
                      <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                        下单关键词
                        </span>
                        <el-input v-model="itl.orderKeys"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="添加" label-width="35%">
                        <el-input v-model="itl.orderAdd"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="单，备用关键词" label-width="42%">
                        <el-input v-model="itl.orderBackKey" placeholder="(选填)备用关键词"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" style="padding-left: 3%;text-align: right" v-if="itl.isShowRemove">
                      <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                 @click="removeOrderKeys('imageAry', itl)"></el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="5">
                    <el-col :span="24">
                      <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                        <el-col :span="12" style="padding-left: 1rem;">
                          <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('imageAry')">
                            <i class="el-icon-plus"></i>
                            添加关键词
                          </el-button>
                        </el-col>
                        <el-col :span="12" style="line-height: 43px;">
                          <span>总计：<span style="color: red">{{ totalImageContent }}</span>单</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row v-if="dialogForm.imageContent">
                    <el-col :span="24">
                      <el-row :gutter="2" align="middle" type="flex">
                        <el-col :span="24" style="background-color: mistyrose;max-height: 30px;margin: 5px;">
                          <span style="font-size: smaller;margin: 5px;">设置图文字好评内容</span>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0" class="contentCls" v-for="(submIt, index) in dialogForm.imageContentAry"
                              :key="index">
                        <el-col :span="24">
                          <el-row :gutter="2">
                            <el-col :span="24"
                                    style="background-color: mistyrose;max-height: 30px;margin: 5px;width: 99%;">
                              <span style="font-size: smaller;margin: 5px;">设置地{{ index + 1 }}单文字好评内容</span>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0">
                            <el-col :span="16">
                              <el-form-item label-width="1%">
                                <el-input v-model="submIt.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0">
                            <el-col :span="20">
                              <el-form-item label-width="1%">
                                <el-input type="textarea" v-model="submIt.reviewContent"
                                          placeholder="(选填)完整的评价内容， 最多999个字。未填写则在买手端提醒买手自由发挥。"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="5" class="itemCls" style="margin-bottom: 10px;">
                            <el-col :span="4">
                              <el-form-item label-width="6%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:0})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isImageShow(submIt, 0)" :src="getImageUrl(submIt, 0)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="6%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:1})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isImageShow(submIt, 1)" :src="getImageUrl(submIt, 1)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="6%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:2})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isImageShow(submIt, 2)" :src="getImageUrl(submIt, 2)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="6%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:3})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isImageShow(submIt,3)" :src="getImageUrl(submIt, 3)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="6%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:4})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isImageShow(submIt, 4)" :src="getImageUrl(submIt, 4)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="5" align="center" style="margin: 10px 0px;">
          <el-col :span="24">
            <el-row style="padding-left: 6.3%">
              <el-col :span="6" style="text-align: right;line-height: 20px;margin-right: 0.5rem">
                <el-checkbox v-model="dialogForm.videoChecked" @change="taskChanged('videoAry')">指定视频好评任务(+2.0金/单)
                </el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="2" v-if="dialogForm.videoChecked"
                    style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
              <el-col :span="24">
                <div>
                  <el-row :gutter="0" class="keywordCls" align="middle" type="flex" v-for="ita in dialogForm.videoAry">
                    <el-col :span="6">
                      <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                        下单关键词
                        </span>
                        <el-input v-model="ita.orderKeys"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="添加" label-width="35%">
                        <el-input v-model="ita.orderAdd"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="单，备用关键词" label-width="42%">
                        <el-input v-model="ita.orderBackKey" placeholder="(选填)备用关键词"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" style="padding-left: 3%;text-align: right" v-if="ita.isShowRemove">
                      <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                 @click="removeOrderKeys('videoAry', ita)"></el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="5">
                    <el-col :span="24">
                      <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                        <el-col :span="12" style="padding-left: 1rem;">
                          <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('videoAry')">
                            <i class="el-icon-plus"></i>
                            添加关键词
                          </el-button>
                        </el-col>
                        <el-col :span="12" style="line-height: 43px;">
                          <span>总计：<span style="color: red">{{ totalVideoContent }}</span>单</span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row v-if="dialogForm.videoContent">
                    <el-col :span="24">
                      <el-row :gutter="2" align="middle" type="flex">
                        <el-col :span="24" style="background-color: mistyrose;max-height: 30px;margin: 5px;">
                          <span style="font-size: smaller;margin: 5px;">设置视频好评内容</span>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0" class="contentCls" v-for="(subvIt, index) in dialogForm.videoContentAry"
                              :key="index">
                        <el-col :span="24">
                          <el-row :gutter="2">
                            <el-col :span="24"
                                    style="background-color: mistyrose;max-height: 30px;margin: 5px;width: 99%;">
                              <span style="font-size: smaller;margin: 5px;">设置地{{ index + 1 }}单文字好评内容</span>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0">
                            <el-col :span="16">
                              <el-form-item label-width="1%">
                                <el-input v-model="subvIt.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0">
                            <el-col :span="20">
                              <el-form-item label-width="1%">
                                <el-input type="textarea" v-model="subvIt.reviewContent"
                                          placeholder="(选填)完整的评价内容， 最多999个字。未填写则在买手端提醒买手自由发挥。"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0" class="itemCls">
                            <el-col :span="24" id="videoTag">
                              <el-form-item label-width="1%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="video/mp4"
                                    :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:0})"
                                    :on-remove="handleAvatarRemove">
                                  <video v-if="isVideoShow(subvIt, 0)" width="220" height="220" controls>
                                    <source :src="getVideoUrl(subvIt, 0)" type="video/mp4">
                                  </video>
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="0" class="itemCls" style="margin-bottom: 10px;">
                            <el-col :span="4">
                              <el-form-item label-width="4%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:1})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isVideoShow(subvIt, 1)" :src="getVideoUrl(subvIt, 1)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="4%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:2})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isVideoShow(subvIt, 2)" :src="getVideoUrl(subvIt, 2)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="4%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:3})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isVideoShow(subvIt, 3)" :src="getVideoUrl(subvIt, 3)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="4%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:4})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isVideoShow(subvIt,4)" :src="getVideoUrl(subvIt, 4)" class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                            <el-col :span="4">
                              <el-form-item label-width="4%">
                                <el-upload
                                    action="https://api.weiquanai.com/taskservice/file/upload"
                                    :headers="myheader"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpg,image/jpeg"
                                    :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:5})"
                                    :on-remove="handleAvatarRemove">
                                  <img v-if="isVideoShow(subvIt, 5)" :src="getVideoUrl(subvIt, 5)"
                                       class="avatar">
                                  <i v-else class="el-icon-plus"></i>
                                </el-upload>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="clearfix"
             style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
          <span style="color: #FFFFFF; font-size: 1rem">发布时间设置</span>
        </div>
        <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;" class="a">
            <el-form-item label="时间类型" prop="selectTimeModel" label-width="19%">
              <span slot="label">
                <span style="color: red; font-size:small">必填</span>
                时间类型
              </span>
              <el-radio-group v-model="dialogForm.selectTimeModel" @change="timeModelChange">
                <el-radio :label="0">间隔模式</el-radio>
                <el-radio :label="1">时间段模式</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="dialogForm.modelTagShow">
          <el-row :gutter="0" style="margin-left: 1%">
            <el-col :span="24" style="color: red;font-size: 12px">
              <div>
                <span>计划放单总单数必须等于发布任务总量，间隔分钟等于0默认开始时间一到一起发布</span>
              </div>
              <div>
              <span>例1：开始时间
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>，每隔
                <span style="color: #1F9FFF">0</span>分钟放出
                <span style="color: #1F9FFF">10</span>单,共放
                <span style="color: #1F9FFF">10</span>单
              </span>
              </div>
              <div>
              <span>即
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>放出
                <span style="color: #1F9FFF">10</span>单
              </span>
              </div>
              <div>
              <span>例2：开始时间
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>，每隔
                <span style="color: #1F9FFF">30</span>分钟放出
                <span style="color: #1F9FFF">2</span>单，共放
                <span style="color: #1F9FFF">10</span>单
              </span>
              </div>
              <div>
              <span>即
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>开始，每
                <span style="color: #1F9FFF">30</span>分钟放
                <span style="color: #1F9FFF">2</span>单，共放
                <span style="color: #1F9FFF">10</span>单，放出明细如下：
              </span>
              </div>
              <div>
              <span>
                <span style="color: #1F9FFF">10:00:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">10:30:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">11:00:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">11:30:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">12:00:00</span>放出
                <span style="color: #1F9FFF">2</span>单
              </span>
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="2" style="border: 1px solid red;margin: 5px;">
            <el-col :span="24">
              <div>
                <el-row :gutter="0" class="keywordCls" align="middle" type="flex"
                        v-for="(planit, index) in dialogForm.orderPlanAry" :key="planit">
                  <el-col :span="10">
                    <el-form-item label="开始时间" label-width="30%">
                      <el-date-picker
                          v-model="planit.orderPlanTime"
                          type="datetime"
                          placeholder="选择日期时间"
                          default-time="12:00:00">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item label="每隔" label-width="40%">
                      <el-input v-model="planit.spaceMinute"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="分钟放出" label-width="58%">
                      <el-input v-model="planit.oplanNum"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="单，共放" label-width="58%">
                      <el-input v-model="planit.oplanTotal"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">
                    <el-form-item label="单" label-width="8%">
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="padding-left: 3%;text-align: right" v-if="planit.isShowRemove">
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                               @click="removeOrderKeys('orderPlanAry', planit)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="24">
              <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                <el-col :span="12" style="padding-left: 1rem;">
                  <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('orderPlanAry')">
                    <i class="el-icon-plus"></i>
                    添加放单计划
                  </el-button>
                </el-col>
                <el-col :span="12" style="line-height: 43px;">
                  <span>总计：<span style="color: red">{{ totalAllPlanNum || 0 }}/{{ totalContentCon }}</span>单</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row :gutter="2">
            <el-col :span="24" style="color: red;font-size: 12px">
              <div>
                1.计划放单总单数必须等于发布任务总量，放单时间不能小于当前时间
              </div>
              <div>
                2.将按下列时间段，到点自动放单
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="0">
            <el-col :span="24" class="planCls">
              <el-row :gutter="2" style="margin-top: 2%">
                <el-col :span="10">
                  <el-form-item label="开始时间" label-width="26%">
                    <el-date-picker
                        v-model="dialogForm.planStartTime"
                        type="datetime"
                        :picker-options="expireTimeOption"
                        placeholder="选择日期时间"
                        default-time="12:00:00">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="14" style="line-height: 40px">
                  <span>总计：<span style="color: red">{{ totalAllHourNum }}/{{ totalContentCon }}</span>单</span>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row :gutter="2">
                <el-col :span="24">
                  <el-row :gutter="2" style="margin: 0px 5px;">
                    <el-col :span="3" v-for="hourIt in getPlanSpaceData(0)">
                      <el-form-item :label="hourIt.hour.toString().concat('点')" label-width="38%">
                        <el-input :disabled="isDisabled(hourIt.hour)" type="text"
                                  onkeyup="value=value.replace(/[^\d]/g,'')"
                                  size="small" v-model="hourIt.orderNum"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="2" style="margin: 0px 5px;">
                    <el-col :span="3" v-for="hourIt in getPlanSpaceData(8)">
                      <el-form-item :label="hourIt.hour.toString().concat('点')" label-width="38%">
                        <el-input :disabled="isDisabled(hourIt.hour)" type="text"
                                  onkeyup="value=value.replace(/[^\d]/g,'')"
                                  size="small" v-model="hourIt.orderNum"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="2" style="margin: 0px 5px;">
                    <el-col :span="3" v-for="hourIt in getPlanSpaceData(16)">
                      <el-form-item :label="hourIt.hour.toString().concat('点')" label-width="38%">
                        <el-input :disabled="isDisabled(hourIt.hour)" type="text"
                                  onkeyup="value=value.replace(/[^\d]/g,'')"
                                  size="small" v-model="hourIt.orderNum"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <div class="clearfix"
             style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
          <span style="color: #FFFFFF; font-size: 1rem">选择增值服务</span>
        </div>
        <service-attarch-component ref="childdata"></service-attarch-component>
        <el-divider></el-divider>
        <div class="clearfix"
             style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
          <span style="color: #FFFFFF; font-size: 1rem">商家附加要求</span>
        </div>
        <el-row>
          <el-col span="24">
            <el-row>
              <el-col span="24">
                <span style="color: red; font-size: 0.5rem">如有需要备注可添加图片，最多可添加3张，图片中不要显示店铺名或商品名，避免用户直接搜索！</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 2%;">
              <el-col span="8">
                <el-upload
                    class="avatar-uploader"
                    action="https://api.weiquanai.com/taskservice/file/upload"
                    :headers="myheader"
                    :show-file-list="false"
                    accept="image/png,image/gif,image/jpg,image/jpeg"
                    :on-success="handleB2cAttarchSuccess.bind(null, {index:0})"
                    :on-remove="handleAvatarRemove">
                  <img v-if="dialogForm.firstImageUrl"
                       :src="dialogForm.firstImageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
              <el-col span="8">
                <el-upload
                    class="avatar-uploader"
                    action="https://api.weiquanai.com/taskservice/file/upload"
                    :headers="myheader"
                    :show-file-list="false"
                    accept="image/png,image/gif,image/jpg,image/jpeg"
                    :on-success="handleB2cAttarchSuccess.bind(null, {index:1})"
                    :on-remove="handleAvatarRemove">
                  <img v-if="dialogForm.secondImageUrl"
                       :src="dialogForm.secondImageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
              <el-col span="8">
                <el-upload
                    class="avatar-uploader"
                    action="https://api.weiquanai.com/taskservice/file/upload"
                    :headers="myheader"
                    :show-file-list="false"
                    accept="image/png,image/gif,image/jpg,image/jpeg"
                    :on-success="handleB2cAttarchSuccess.bind(null, {index:2})"
                    :on-remove="handleAvatarRemove">
                  <img v-if="dialogForm.thirdImageUrl"
                       :src="dialogForm.thirdImageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
            </el-row>
            <el-row style="margin-top: 2%;">
              <el-col span="24">
                <span style="color: red; font-size: 0.5rem">商家备注内容</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 2%;">
              <el-col span="24">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="重要！如果对用户有特别的要求，请在备注里注明，用户在做任务时会看到， 最多不能超过300字（任务备注只是商家要求，我们只能做到传达给用户但不会强制用户按要求执行）"
                    v-model="dialogForm.remarksContent">
                </el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">下一步</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="任务发布信息确认" :visible.sync="dialogFormConfirmVisible">
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
        <span style="color: #FFFFFF; font-size: 1rem">任务信息</span>
      </div>
      <el-table :data="dialogFormConfirm"
                style="width: 100%">
        <el-table-column prop="taskType" label="类型">
        </el-table-column>
        <el-table-column prop="shopInfo" label="店铺">
        </el-table-column>
        <el-table-column prop="returnMoneyType" label="返款">
        </el-table-column>
        <el-table-column prop="goodTitle" label="商品标题">
        </el-table-column>
      </el-table>
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.5rem;">
        <span style="color: #FFFFFF; font-size: 1rem">收费明细</span>
      </div>
      <el-table :data="dialogFormConfirm[0].moneyDetails"
                show-summary
                :span-method="arraySpanMethod"
                style="width: 100%">
        <el-table-column prop="taskClass" label="类型">
        </el-table-column>
        <el-table-column prop="moneyFree" label="本金">
        </el-table-column>
        <el-table-column prop="baseServiceMoney" label="基础服务费">
        </el-table-column>
        <el-table-column prop="attachMoney" label="附加服务费">
        </el-table-column>
        <el-table-column prop="reviewServiceMoney" label="评分服务费">
        </el-table-column>
        <el-table-column prop="moneyReward" label="赏金">
        </el-table-column>
        <el-table-column prop="expressMoney" label="运费">
        </el-table-column>
        <el-table-column prop="taskNumbers" label="任务数">
        </el-table-column>
        <el-table-column prop="totalMoney" label="小计">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmRelease" size="mini" type="primary">确认发布</el-button>
        <el-button @click="saveWaitPay" size="mini">保存待支付</el-button>
      </div>
    </el-dialog>
    -->
    <customer-service-component></customer-service-component>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import VDistpicker from 'v-distpicker';
import {planData} from "../../lib/orderPlanData";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import {getAllShops, getShops} from "../../api/b2cbusiness/b2c_shopmanage";
import {compareTime} from "../../lib/utils";
import ServiceAttarchComponent from "../b2ccomponents/ServiceAttarchComponent";
import {
  getTaobaoGoodInfo,
  addTask,
  getTaskInfo,
  getTaskVoInfo,
  confirmTaskRelease
} from "../../api/b2cbusiness/b2c_tasklist";
import {getJwtToken} from "../../lib/utils";
import {getAllListExpress} from "../../api/b2cbusiness/b2c_express";
import CustomerServiceComponent from "../../components/CustomerServiceComponent";

export default {
  name: "BusinessTaskManagelist",
  mixins: [MixinCUD],
  components: {
    VDistpicker,
    CustomerServiceComponent,
    ServiceAttarchComponent
  },
  data() {
    return {
      /*
      expireTimeOption: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      */
      myheader: {
        JWTHeaderName: ""
      },
      payReleaseBtnCkicked: false, //新增支付发布的点击限制
      tableData: [
        /*{
          avatar: {
            img: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            size: "small",
            shopName: "q点数码旗舰店",
            dateTime: "2021/6/15 19:35:06 ",
            typeName: "手机淘宝无截图版"
          },
          orderNum: 3,
          taskNum: "890288",
          status: "进行中",
          image: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
          productTitle: "华为小米手机适用智能儿童电话手表防水时尚户外全网通小学生天才男女孩定位可插卡4G正品多功能超长待机",
        }

         */
      ],
      allShops: [],
      allTaskTypes:[],
      statusOptions: [
        {
          flag:"202109020001" ,
          value:"待放出",
        },
        {
          flag: "202109010001" ,
          value:"准备中",
        },
        {
          flag: "202109010002" ,
          value:"已下单",
        },
        {
          flag:"202109020002" ,
          value:"复活",
        },
        {
          flag: "202205090001" ,
          value:"超时发货",
        },
        {
          flag: "202110040002" ,
          value:"申诉审核中",
        },
        {
          flag:"202109030002" ,
          value:"申诉完成",
        },
        {
          flag: "202109030003" ,
          value:"退款审核中",
        },
        {
          flag: "202109030004" ,
          value:"已退款",
        },
        {
          flag:"202109030005" ,
          value:"已完成",
        }
      ],
      queryFormRefName:"queryForm",
      queryForm: {
        taskType: null,
        shopInfo: null,
        taskId: null,
        status: null,
        timeRange: [],
        goodUrl: ''
      },
      totalAllOrderNum: 0,
      /*
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      options: [],
      allShops: [],
      allExpress: [],
      goodsTableVisible: false,
      dialogForm: {
        taskType: "",
        shopInfo: "",
        taskName: "",
        productUrl: "",
        goodTitle: "",
        goodImgUrl: "",
        businessPrice: "",
        billProductNum: "1",
        sreachPrice: "",
        goodPriceTotal: 0,
        goodsAry: [],
        couponUrl: "",   //优惠券链接
        isFreeShipping: 1, //是否包邮
        logisticsCompany: "", //物流公司
        goodsSortType: 0, //商品排序的方式
        recivePersons: "", //商品现有收货人
        startPrice: "", //价格区间-价格起步
        endPrice: "", //价格区间-价格终点
        goodAddress: "", //商品所在地
        goodInfoAnswer: "", //宝贝详情问答
        orderLeaveMessage: "", //订单留言
        taskChecked: false,
        orderNums: "",
        taskAry: [
          {
            taskOrderType: "",
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            orderColorSize: "",
            isShowRemove: false
          },
        ],
        taskReviewChecked: false,
        textChecked: false,
        textOrdNum: 0,
        textAry: [
          {
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },
        ],
        textContent: false,
        textContentCon: 0,
        textContentAry: [],
        imageChecked: false,
        imageOrdNum: "",
        imageAry: [
          {
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },
        ],
        imageContent: false,
        imageContentCon: 0,
        imageContentAry: [],
        videoChecked: false,
        videoOrdNum: "",
        videoAry: [
          {
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },
        ],
        videoContent: false,
        videoContentCon: 0,
        videoContentAry: [],
        
        selectTimeModel: 0,
        modelTagShow: true,
        orderPlanAry: [
          {
            orderPlanTime: "",
            spaceMinute: "",
            oplanNum: "",
            oplanTotal: "",
            isShowRemove: false
          },
        ],
        planStartTime: "",
        detail: [...planData],
        businessAttarchQuest: "",
        firstImageUrl: "",
        secondImageUrl: "",
        thirdImageUrl: "",
        remarksContent: ""
      },
      dialogFormConfirmVisible: false,
      dialogFormConfirm: [
        {
          moneyDetails: []
        }
      ],
       */
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    getShops({shopNum:null,
      shopName:null,
      shopUsername:null,
      shopType: null,
      shopMajorTypeId:null,
      status:null,
      shopGroup:null}).then(res=>{
      if (res.success){
        console.log(res.data)
        this.allShops = res.data;
      }
    });
    getAllTaskType().then(res => {
      console.log(res.data)
      this.allTaskTypes = res.data;
    });
    
    getAllTaskType().then(res => {
      console.log(res.data)
      this.options = res.data;
    });

    this.myheader.JWTHeaderName = getJwtToken();

    getAllListExpress().then(res => {
      console.log(res.data)
      this.allExpress = res.data;
    });

    getTaskInfo(this.queryForm, this.pagination).then(res => {
      console.log(res.data);
      if (res.success) {
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    });
  },
  activated() {
    getShops({shopNum:null,
      shopName:null,
      shopUsername:null,
      shopType: null,
      shopMajorTypeId:null,
      status:null,
      shopGroup:null}).then(res=>{
      if (res.success){
        console.log(res.data)
        this.allShops = res.data;
      }
    });
    getAllTaskType().then(res => {
      console.log(res.data)
      this.allTaskTypes = res.data;
    });
    getTaskInfo(this.queryForm, this.pagination).then(res => {
      //console.log(res.data);
      if (res.success) {
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    });
  },
  computed: {
    isShowPayBtn(){
      return function (itemVal) {
        //console.log(itemVal)
        for (let itemkey in itemVal.statusInfo){
          //console.log(itemkey)
          if (itemkey != "保存待扣款"){
            return false;
          }
        }
        return true;
      }
    }
    /*
    isImageShow() {
      return function (val, index) {
        if (val.imageUrls != undefined && val.imageUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getImageUrl() {
      return function (val, index) {
        console.log(val, index);
        if (val.imageUrls != undefined && val.imageUrls.length > 0) {
          return val.imageUrls[index];
        }
        return null;
      }
    },
    isVideoShow() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getVideoUrl() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > 0) {
          return val.videoUrls[index];
        }
        return null;
      }
    },
    isShowGetLinkBtn(){
      if (this.allShops.length > 0){
        return this.allShops[0].shopTypeId == 1;
      }else{
        return false;
      }
    },
    totalTaskContent: function () {
      if (this.dialogForm.taskAry.length > 0) {
        let con = 0;
        for (let i in this.dialogForm.taskAry) {
          let a = this.dialogForm.taskAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.dialogForm.orderNums = con;
      } else {
        this.dialogForm.orderNums = 0;
      }
      return this.dialogForm.orderNums;
    },
    totalTextContent: function () {
      if (this.dialogForm.textAry.length > 0) {
        let con = 0;
        for (let i in this.dialogForm.textAry) {
          let a = this.dialogForm.textAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.dialogForm.textContentCon = con;
        this.dialogForm.textContent = true;
      } else {
        console.log(this.dialogForm.textContent);
        this.dialogForm.textContent = false;
      }

      if (this.dialogForm.textContent && this.dialogForm.textContentCon > 0) {
        let con = this.dialogForm.textContentCon - this.dialogForm.textContentAry.length;
        if (con > 0) {
          while (con > 0) {
            this.dialogForm.textContentAry.push({
              orderColorSize: "",
              reviewContent: ""
            });
            con = con - 1;
          }
        } else {
          let removeCon = this.dialogForm.textContentAry.length - this.dialogForm.textContentCon;
          this.dialogForm.textContentAry.splice(0, removeCon);
        }
      }
      if (this.dialogForm.textContentCon <= 0) {
        this.dialogForm.textContent = false;
      }
      return this.dialogForm.textContentCon;
    },
    totalImageContent: function () {
      if (this.dialogForm.imageAry.length > 0) {
        let con = 0;
        for (let i in this.dialogForm.imageAry) {
          let a = this.dialogForm.imageAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.dialogForm.imageContentCon = con;
        this.dialogForm.imageContent = true;
      } else {
        this.dialogForm.imageContent = false;
      }

      if (this.dialogForm.imageContent && this.dialogForm.imageContentCon > 0) {
        let con = this.dialogForm.imageContentCon - this.dialogForm.imageContentAry.length;
        if (con > 0) {
          while (con > 0) {
            this.dialogForm.imageContentAry.push({
              orderColorSize: "",
              imageUrls: [],
              reviewContent: ""
            });
            con = con - 1;
          }
        } else {
          let removeCon = this.dialogForm.imageContentAry.length - this.dialogForm.imageContentCon;
          this.dialogForm.imageContentAry.splice(0, removeCon);
        }
      }
      if (this.dialogForm.imageContentCon <= 0) {
        this.dialogForm.imageContent = false;
      }
      return this.dialogForm.imageContentCon;
    },
    totalVideoContent: function () {
      if (this.dialogForm.videoAry.length > 0) {
        let con = 0;
        for (let i in this.dialogForm.videoAry) {
          let a = this.dialogForm.videoAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.dialogForm.videoContentCon = con;
        this.dialogForm.videoContent = true;
      } else {
        this.dialogForm.videoContent = false;
      }

      if (this.dialogForm.videoContent && this.dialogForm.videoContentCon > 0) {
        let con = this.dialogForm.videoContentCon - this.dialogForm.videoContentAry.length;
        if (con > 0) {
          while (con > 0) {
            this.dialogForm.videoContentAry.push({
              orderColorSize: "",
              videoUrls: [],
              reviewContent: ""
            });
            con = con - 1;
          }
        } else {
          let removeCon = this.dialogForm.videoContentAry.length - this.dialogForm.videoContentCon;
          this.dialogForm.videoContentAry.splice(0, removeCon);
        }
      }
      if (this.dialogForm.videoContentCon <= 0) {
        this.dialogForm.videoContent = false;
      }
      return this.dialogForm.videoContentCon;
    },
    totalContentCon: function () {
      this.dialogForm.totalAllOrderNum = (parseInt(this.dialogForm.orderNums) || 0) + (parseInt(this.dialogForm.textContentCon) || 0) + (parseInt(this.dialogForm.imageContentCon) || 0)
          + (parseInt(this.dialogForm.videoContentCon) || 0);
      return this.dialogForm.totalAllOrderNum;
    },
    totalAllPlanNum: function () {
      if (this.dialogForm.orderPlanAry.length > 0) {
        let planNum = 0;
        for (let item in this.dialogForm.orderPlanAry) {
          planNum += parseInt(this.dialogForm.orderPlanAry[item].oplanTotal)
        }
        if (planNum > this.dialogForm.totalAllOrderNum) {
          this.$message({message: "放单计划数量大于任务数量，重新填写", type: 'error'});
          for (let item in this.dialogForm.orderPlanAry) {
            this.dialogForm.orderPlanAry[item].oplanTotal = 0;
          }
          return 0;
        }
        return planNum;
      }
      return 0;
    },
    totalAllHourNum: function () {
      if (this.dialogForm.detail.length > 0) {
        let planNum = 0;
        for (let item in this.dialogForm.detail) {
          if (this.dialogForm.detail[item].orderNum != null && this.dialogForm.detail[item].orderNum != "") {
            planNum += parseInt(this.dialogForm.detail[item].orderNum);
          }
        }
        if (planNum > this.dialogForm.totalAllOrderNum) {
          this.$message({message: "放单计划数量大于任务数量，重新填写", type: 'error'});
          for (let item in this.dialogForm.detail) {
            this.dialogForm.detail[item].orderNum = 0;
          }
          return 0;
        }
        return planNum;
      }
      return 0;
    },

     */
  },
  methods: {
    releaseTask(){
      this.$router.push({path:'/home/taskrelease'});
    },
    isSaveWaitToPay(values){
      for (let itemkey in values){
        if (itemkey != "保存待扣款"){
          return false;
        }
      }
      return true;
    },
    goTaskRelease(taskVal){
      //console.log(taskVal)
      if (!this.payReleaseBtnCkicked){
        this.payReleaseBtnCkicked = true;
      }else{
        this.$message.error("请勿重复点击，等待系统处理中");
      }
      if (taskVal.statusInfo.保存待扣款 >= 1&& this.isSaveWaitToPay(taskVal.statusInfo)){
        this.$confirm("确认支付并发布任务？").then(_ => {
          confirmTaskRelease(taskVal).then(res=>{
            if (res.success){
              this.payReleaseBtnCkicked = false;
              this.getData();
              this.$forceUpdate();
              this.$message.success("发布成功");
            }
          }).catch(err => {
            this.payReleaseBtnCkicked = false;
            this.$message({message: err.message, type: 'error'});
          });
        })
      }else{
        this.payReleaseBtnCkicked = false;
        this.$router.push({path:'/home/taskrelease', query: {b2cTaskId:taskVal.b2cTaskId}});
      }
    },
    gotToDetail(taskVal){
      this.$router.push({path:"/home/businesstaskdetails", query: {b2cTaskId:taskVal.b2cTaskId}})
    },
    /*
    taskTypeChange(val){
      console.log(val)
      getAllShops(val).then(res => {
        console.log(res.data);
        this.allShops = res.data;
      });
    },
    confirmRelease() {
      this.dialogFormConfirmVisible = false;
    },
    saveWaitPay() {
      this.dialogFormConfirmVisible = false;
    },
    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      let l = this.dialogFormConfirm.freeDetail.lenght;
      if (rowIndex == l) {
        return {
          rowspan: 0,　　　　　//合并的行数
          colspan: 8
        }
      }
    },

     */
    getData(){
      getTaskInfo(this.queryForm, this.pagination).then(res => {
        //console.log(res.data);
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    setData(data) {
      this.tableData = data;
    },
    /*
    isDisabled(hour) {
      let inputDate = new Date(this.dialogForm.planStartTime);
      if (this.dialogForm.planStartTime == null || this.dialogForm.planStartTime == "") {
        return true;
      }
      let currentDate = new Date();
      if ((inputDate.getDay() == currentDate.getDay())
          && (hour <= currentDate.getHours())) {
        return true;
      }
      return false;
    },
    resetDialogForm() {
    },
    taskChanged(isChecked) {
      if (isChecked == "taskAry") {
        this.dialogForm.taskAry = [];
        this.dialogForm.orderNums = 0;
        if (this.dialogForm.taskChecked) {
          this.dialogForm.taskAry.push({
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            orderColorSize: "",
            isShowRemove: false
          });
        }
      } else if (isChecked == "textAry") {
        this.dialogForm.textAry = [];
        this.dialogForm.textContentCon = 0;
        if (this.dialogForm.textChecked) {
          this.dialogForm.textAry.push({
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },);
        }
      } else if (isChecked == "imageAry") {
        this.dialogForm.imageAry = [];
        this.dialogForm.imageContentCon = 0;
        if (this.dialogForm.imageChecked) {
          this.dialogForm.imageAry.push({
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },);
        }
      } else if (isChecked == "videoAry") {
        this.dialogForm.videoAry = [];
        this.dialogForm.videoContentCon = 0;
        if (this.dialogForm.videoChecked) {
          this.dialogForm.videoAry.push({
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },);
        }
      }
    },

    addData() {
      this.dialogForm.serviceAttarch = this.$refs.childdata.childdata;
      console.log(this.dialogForm)
      addTask(this.dialogForm).then(res => {
        this.$message({message: res.data, type: 'success'});
        //this.submitQueryForm();//新增之后，重新查询table
        this.handleCloseDialog();
        getTaskVoInfo(res.data.id).then(res => {
          console.log(res.data);
          this.dialogFormConfirmVisible = true;
          this.dialogFormConfirm = res.data;
        });
      })
    },
    getServiceAttarchData() {
      this.dialogForm.businessAttarchQuest = this.$refs.childdata;
      console.log("=================================", this.$refs.childdata.childdata);
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.dialogForm.goodImgUrl = res.data;
    },
    handleB2cAttarchSuccess(obj, res, file) {
      console.log(obj, res, file);
      let urlStr = res.data;
      if (obj.index == 0) {
        this.dialogForm.firstImageUrl = urlStr;
      } else if (obj.index == 1) {

        this.dialogForm.secondImageUrl = urlStr;
      } else {
        this.dialogForm.thirdImageUrl = urlStr;
      }
    },
    handleGoodSuccess(obj, res, file) {
      console.log(obj, res, file);
      this.dialogForm.goodsAry[obj.index].goodImageUrl = res.data;
    },
    handleReviewSuccess(obj, res, file) {
      console.log(obj, res, file);
      if (this.dialogForm.imageContentAry[obj.index].imageUrls.length < obj.imgIndex) {
        this.dialogForm.imageContentAry[obj.index].imageUrls.push(res.data);
      } else {
        this.dialogForm.imageContentAry[obj.index].imageUrls.splice(obj.imgIndex, 1, res.data);
      }
    },
    handleReviewVideoSuccess(obj, res, file) {
      console.log(obj, res, file);
      if (this.dialogForm.videoContentAry[obj.index].videoUrls.length < obj.videoIndex) {
        this.dialogForm.videoContentAry[obj.index].videoUrls.push(res.data);
      } else {
        this.dialogForm.videoContentAry[obj.index].videoUrls.splice(obj.videoIndex, 1, res.data);
      }
    },
    handleAvatarRemove(file) {
      console.log(file)
    },
    dateChange() {
      console.log("dateChange", this.dialogForm.planStartTime);
      if (compareTime(this.dialogForm.planStartTime) == 1) {
        console.log("-------")
        let hour = new Date().getHours();
        for (let i in this.dialogForm.detail) {
          if (hour < this.dialogForm.detail[i]) {
            this.dialogForm.detail[i].isDisabled = false;
          }
        }
      }
    },
    getPlanSpaceData(witchData) {
      console.log(witchData, this.dialogForm.detail.slice(witchData, witchData + 8));
      return this.dialogForm.detail.slice(witchData, witchData + 8);
    },
    addShops() {
      this.dialogFormVisible = false;
      this.$router.push('/home/storemanagelist');
    },
    addGoods() {
      this.goodsTableVisible = true;
      let goodInfo = {
        goodImageUrl: "",
        goodUrl: "",
        mainKey: "",
        goodTitle: "",
        goodPrice: "",
        goodNum: "",
        goodRule: ""
      };
      this.dialogForm.goodsAry.push(goodInfo);
    },
    removeGood(good) {
      this.$confirm("确认删除当前商品？").then(_ => {
        let index = this.dialogForm.goodsAry.indexOf(good);
        this.dialogForm.goodsAry.splice(index, 1);
        if (this.dialogForm.goodsAry.length <= 0) {
          this.goodsTableVisible = false;
        }
      });
    },
    addOrderKeys(orderKeys) {
      if (orderKeys == "taskAry") {
        this.dialogForm.taskAry.push({
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          orderColorSize: "",
          isShowRemove: true
        });
      } else if (orderKeys == "textAry") {
        this.dialogForm.textAry.push({
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          isShowRemove: true
        });
      } else if (orderKeys == "imageAry") {
        this.dialogForm.imageAry.push({
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          isShowRemove: true
        });
      } else if (orderKeys == "videoAry") {
        this.dialogForm.videoAry.push({
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          isShowRemove: true
        });
      } else if (orderKeys == "orderPlanAry") {
        this.dialogForm.orderPlanAry.push({
          orderPlanTime: "",
          spaceMinute: "",
          oplanNum: "",
          oplanTotal: "",
          isShowRemove: true
        });
      }
    },
    removeOrderKeys(orderKeys, obj) {
      if (orderKeys == "taskAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.dialogForm.taskAry.indexOf(obj);
          if (this.dialogForm.taskAry.length > 1) {
            this.dialogForm.taskAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "textAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.dialogForm.textAry.indexOf(obj);
          if (this.dialogForm.textAry.length > 1) {
            this.dialogForm.textAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "imageAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.dialogForm.imageAry.indexOf(obj);
          if (this.dialogForm.imageAry.length > 1) {
            this.dialogForm.imageAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "videoAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.dialogForm.videoAry.indexOf(obj);
          if (this.dialogForm.videoAry.length > 1) {
            this.dialogForm.videoAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "orderPlanAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.dialogForm.orderPlanAry.indexOf(obj);
          if (this.dialogForm.orderPlanAry.length > 1) {
            this.dialogForm.orderPlanAry.splice(index, 1);
          }
        });
      }
    },
    timeModelChange() {
      if (this.dialogForm.modelTagShow == null) {
        this.dialogForm.modelTagShow = true;
      }
      this.dialogForm.modelTagShow = !this.dialogForm.modelTagShow;
      if (this.dialogForm.modelTagShow) {
        this.dialogForm.orderPlanAry = [];
        this.dialogForm.orderPlanAry.push({
          orderPlanTime: "",
          spaceMinute: "",
          oplanNum: "",
          oplanTotal: "",
          isShowRemove: false
        });
      } else {
        this.dialogForm.detail = [];
        this.dialogForm.detail = [...planData];
      }
    },
    getTaobaoGood(good) {
      if (good != null) {
        getTaobaoGoodInfo(good.goodUrl).then(res => {
          console.log(res.data);
          good.goodImageUrl = res.data.goodImage;
          good.goodTitle = res.data.goodTitle;
          good.businessPrice = res.data.businessPrice;
        });
      } else {
        getTaobaoGoodInfo(this.dialogForm).then(res => {
          console.log(res.data);
          this.dialogForm.goodImgUrl = res.data.goodImage;
          this.dialogForm.goodTitle = res.data.goodTitle;
          this.dialogForm.businessPrice = res.data.businessPrice;
        });
      }
    },
    onProvinceSelected(val) {
      console.log(val);
      this.dialogForm.goodAddress = val.province.value;
    },

     */
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style lang="scss" scoped>
table tr td {
  border-right: 1px solid #04befe;
  border-bottom: 1px solid #04befe;
  width: 4.33%;
  text-align: center;
  margin: 5px;
}

.el-form {
  margin-top: 20px;
}

.titleCls {
  line-height: 30px;
  position: relative;
}

.titleCls span {
  vertical-align: middle;
}

.titleCls span:nth-child(2) {
  padding-left: 20px;
}

.titleCls span:nth-child(3) {
  padding-left: 20px;
}

.titleCls span:last-child {
  float: right;
  margin-top: 0.8%;
  padding-right: 20px;
  color: #F85554;
}

.item-card {
  margin-bottom: 20px;
}

/* 定义keyframe动画，命名为blink */
@keyframes blink {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* 添加兼容性前缀 */
@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* 定义blink类*/
.blink {
  color: red;
  animation: blink 1s linear infinite;
  /* 其它浏览器兼容性前缀 */
  -webkit-animation: blink 1s linear infinite;
  -moz-animation: blink 1s linear infinite;
  -ms-animation: blink 1s linear infinite;
  -o-animation: blink 1s linear infinite;
}

.boxself {
  border: 1px solid red;
  margin-left: 28%;
  font-size: smaller;
  height: 100%;

  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }

  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .avatar {
    width: 100px;
    height: 100px;
  }

  .el-input /deep/ .el-input__inner {
    height: 28px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__label {
    font-size: smaller;
  }

}

#videoTag {
  /deep/ .el-upload--picture-card {
    width: 220px;
    height: 220px;
  }

  /deep/ .el-upload {
    border: 1px dashed gray;
    border-radius: 5px;
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .avatar {
    width: 220px;
    height: 220px;
  }
}

.itemCls {
  /deep/ .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }

  /deep/ .el-upload {
    border: 1px dashed gray;
    border-radius: 5px;
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .avatar {
    width: 120px;
    height: 120px;
  }
}

.keywordCls {
  max-height: 30px;
  margin: 5px 2px;
  background-color: lightpink;

  .el-input /deep/ .el-input__inner {
    height: 28px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__label {
    font-size: smaller;
  }
}

.contentCls {
  border: 1px solid red;
  border-radius: 5px;
  margin: 5px;

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 1%;
  }
}

.a {
  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item /deep/ .el-form-item__label {
    margin: 2px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 2px;
  }
}

.planCls {
  border: 1px solid red;
  margin: 5px;

  .el-divider {
    margin: 8px 0;
    background: 0 0;
    border-top: 1px solid red;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
}

.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 220px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px;
  text-align: center;
}

.avatar {
  width: 220px;
  height: 220px;
  display: block;
}

</style>
